import { Package, TruckIcon, Users, type LucideIcon } from 'lucide-react';
import type { TFunction } from 'i18next';
import type { DataLayerType } from '../model/types';

export interface LayerConfig {
  label: string;
  labelKey: string;
  defaultLabel: string;
  icon: LucideIcon;
  color: string;
  apiEndpoint: string;
}

export const DATA_LAYER_CONFIG: Record<DataLayerType, Omit<LayerConfig, 'label'>> = {
  stock: {
    labelKey: 'hover.stockOnHand',
    defaultLabel: 'Stock on Hand',
    icon: Package,
    color: 'text-blue-600',
    apiEndpoint: '/stock'
  },
  releases: {
    labelKey: 'map.layer.releases',
    defaultLabel: 'Releases',
    icon: TruckIcon,
    color: 'text-green-600',
    apiEndpoint: '/releases'
  },
  requests: {
    labelKey: 'map.layer.requests',
    defaultLabel: 'Requests',
    icon: Users,
    color: 'text-purple-600',
    apiEndpoint: '/requests'
  }
} as const;

export function getDataLayerConfig(layer: DataLayerType, t?: TFunction): LayerConfig {
  const config = DATA_LAYER_CONFIG[layer];
  return {
    ...config,
    label: t ? t(config.labelKey, config.defaultLabel) : config.defaultLabel
  };
}

export function createDefaultVisibility(activeLayer: DataLayerType): Record<DataLayerType, boolean> {
  return {
    stock: activeLayer === 'stock',
    releases: activeLayer === 'releases',
    requests: activeLayer === 'requests'
  };
}
